import React, { useEffect, useState } from 'react'
import { LeasesBasicDetails, LeasesNav } from '../../elements'
import { Box, Button, Checkbox, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material'
import { useSelector } from 'react-redux';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import { trackActivity } from '../../../utils/mixpanel';
import AddEditAdditionalTax from '../components/AddEditAdditionalTax';
import { PermissionWrapper } from '../../../wrappers';
import ExportFileTypeComp from '../../../shared_elements/components/ExportFileTypeComp';
import { DeletePopUp, FilterComponent, NoRecordFound, PageLoader, Pagination, PopOverCTA, STableLoader } from '../../../shared_elements';
import BackToLeaseList from '../../elements/BackToLeaseList';
import ModuleWiseRevisionHistory from '../../../shared_elements/components/ModuleWiseRevisionHistory';
import { useParams } from 'react-router';
import { isMobile } from "react-device-detect";
import TaxList from '../components/TaxList';
import { globalDeleteService, globalGetParamsService, globalGetService, globalPutService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { enqueueSnackbar } from 'notistack';
import RevisionHistory from '../../../shared_elements/components/RevisionHistory';
import { ButtonLoader } from '../../../shared_elements/components';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { RoleBaseAccess } from '../../../hoc';

const TABLE_HEIGHT = 'calc(100vh - 228px)';

const invoiceTypeOptions = [
    { label: 'Reserve', value: 1 },
    { label: 'Rental', value: 2 },
    { label: 'Penalty', value: 3 },
    { label: 'Debit', value: 4 },
    { label: 'Credit', value: 5 },
    { label: 'Adhoc', value: 9 },
    { label: 'Security Deposit', value: 6 },
    { label: 'Management Fee', value: 10 },
];
const TaxHd = ({ sortInfo, createSortHandler, toggleBulkOps, item, bulk }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Additional Tax`, page_type: page_type, })
    }
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={sortInfo.sort_by === key ? true : false}
                direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )
    }
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header">
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "additional_tax", operationType: ['D'] }}>
                        <Checkbox disableRipple color='primary' size='small' onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell sx={{ minWidth: '145px' }}> {tableSorting('name', 'Tax Name')}</TableCell>
                <TableCell sx={{ minWidth: '110px' }}> {tableSorting('tax_percentage', 'Tax Rate (%)')}</TableCell>
                <TableCell sx={{ minWidth: '110px' }}> {tableSorting('invoice_types', 'Invoice Type(s)')}</TableCell>
                <TableCell sx={{ minWidth: '110px' }}> {tableSorting('status', 'Status')}</TableCell>
            </TableRow>
        </TableHead>
    )
}

const AdditionalTaxes = () => {
    const { leaseBasicDetails } = useSelector((state) => state.leases);
    const [addEditAdditionalTax, setAddEditAdditionalTax] = useState({})
    const { leaseSlug } = useParams()
    const params = { leaseSlug: leaseSlug };
    const [taxList, setTaxList] = useState({})
    const [isExport, seIsExport] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [filter, setFilter] = useState({});
    const [deleteTax, setDeleteTax] = useState({ modal: false, data: null })
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [queryConfig, setQueryConfig] = useState({
        page: taxList?.pagination?.page || 1,
        per_page: taxList?.pagination?.per_page || 50,
    })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' });
    useEffect(() => {
        trackActivity('Page Viewed', { page_title: 'Additional Tax' })
        getTaxList(queryConfig, 'skeletonLoader')
    }, [])
    const taxFilterMenu = {
        name: { title: 'Tax name', inputType: 'text' },
        tax_percentage: { title: 'Tax Rate', inputType: 'number', is_decimal: true },
        invoice_types: { title: 'Invoice Type(s)', inputType: 'dropdown', options: invoiceTypeOptions || [], valueKey: 'value', labelKey: 'label', multiple: true },
        status: { title: 'Status', inputType: 'dropdown', options: [{label:'Active',value:true},{label:'Inactive',value:false,}] || [], valueKey: 'value', labelKey: 'label', multiple: true },
        // is_included_in_funds: { title: 'Include in Item Level', inputType: 'checkbox' },
        // is_applied_on_total: { title: 'Include in Total', inputType: 'checkbox' },
    }
    const getTaxList = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetParamsService(`lease/${leaseSlug}/additional-tax`, query)
            .then(response => {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                if (checkApiStatus(response)) {
                    setTaxList(response.data.data)
                }
            })
    }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Additional Tax`, page_type: page_type, })
    }
    const handleExport = (fileType) => {
        let query = { lease_slug: leaseSlug, export: true, file_type: fileType, ...filter }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = { ...query, sort: sortInfo?.sort, sort_by: sortInfo?.sort_by }
        }
        seIsExport(true);
        globalGetParamsService(`lease/${leaseSlug}/additional-tax`, query).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar( response?.data.message,{ variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
                seIsExport(false);
            }
        })
    }
    const onApplyFilter = (query) => {
        setFilter(query);
        getTaxList({ ...query, page: 1, per_page: taxList?.pagination?.per_page || 50, lease_slug: params?.leaseSlug }, '');
    }
    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key }
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getTaxList({
            ...filter,
            ...sortQuery,
            page: taxList?.pagination?.current_page || 1,
            per_page: taxList?.pagination?.per_page || 50,
            lease_slug: params?.leaseSlug
        });
    }
    const onInvStatus = async (item) => {
        try {
            setLoading(true)
            const response = await globalPutService(`lease/${leaseSlug}/additional-tax/${item?.slug}`, { ...item, status: !item.status });
            setLoading(false)

            if (checkApiStatus(response)) {
                getTaxList({...sortInfo, ...filter, page: taxList?.pagination?.current_page || 1, per_page: taxList?.pagination?.per_page || 50,});
            }
        } catch {
            setLoading(false)
        }
    }
    const onDeleteTax = () => {
        const idsToDelete = deleteTax?.modal && deleteTax?.data?.id ? [deleteTax?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        setLoading(true)
        globalDeleteService(`lease/${leaseSlug}/additional-tax`, { ids: idsToDelete })
            .then(response => {
                setLoading(false)
                if (checkApiStatus(response)) {
                    setDeleteTax({ modal: false, data: null });
                    setBulk({ modal: false, ids: [], title: '', type: '' });
                    getTaxList({...sortInfo, ...filter,...queryConfig})
                    enqueueSnackbar(response.data.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } })
                    trackActivity('Item Deleted', { page_title: `Delete Additional Tax`, success_msg: response?.data?.message, item_ids: deleteTax?.data|| bulk?.ids, response: response?.data })
                } else {
                    enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
                    trackActivity('Item Deleted', { page_title: `Delete Additional Tax`, error_msg: response?.data?.message, item_ids: deleteTax?.data|| bulk?.ids, response: response?.data })
                }
            })
    }

    const toggleBulkOps = (flag, type, item) => {
        setBulk((prev) => {
            const prevIds = Array.isArray(prev?.ids) ? prev.ids : [];
            if (type === 'bulk') {
                return { ...prev, type: 'bulk', ids: flag ? (Array.isArray(item) ? item : []) : [] };
            }

            return {
                ...prev,
                type: 'single',
                ids: flag ? [...prevIds, item] : prevIds.filter(optionItem => optionItem?.id !== item?.id),
            };
        });
    }

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
                <LeasesNav />
                <div className='lease-details-content'>
                    <Paper square className="responsive-paper">
                        <Grid container spacing={0.5} className="responsive-grid">
                            <Grid item size={{ md: 12, xs: 12 }} className="menu-container lease-list-link-mt">
                                <BackToLeaseList />
                            </Grid>
                            <Grid md={4} xs={12} size='grow' sx={{ minWidth: 0, overflow: 'hidden' }}>
                                {!skeletonLoader ? <Box display="flex" alignItems="center" gap={1} sx={{ marginTop: '6px', marginLeft: "-2px" }} flexShrink={0}><FilterComponent filter={filter} filterMenu={taxFilterMenu} getResponseBack={onApplyFilter} /></Box> : null}
                            </Grid>
                            <Grid md={4} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <ul className='list-inline lease-details-right-items' style={{ padding: '0px', float: 'right' }}>
                                    <li className='lease-mobile-button revision-history'>
                                        <ModuleWiseRevisionHistory ViewGlobalHistory={() => { setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } }); handleItemClicked('Global Revision HistoryIcon') }} />
                                    </li>
                                    {
                                        bulk?.type && bulk?.ids?.length ?
                                            <>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "additional_tax", operationType: ['D'] }}>
                                                    <li className='lease-mobile-button'>
                                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" color='error' size="small" >{`Delete (${bulk?.ids?.length})`}</Button>
                                                    </li>
                                                </PermissionWrapper>
                                            </> : null
                                    }
                                    {taxList?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15}/> : <ArrowDownwardIcon/>}  variant="outlined" size='small' onClick={() => {handleItemClicked('Export Button'); handleExport() }}> Export </Button> </li> : null}
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "additional_tax", operationType: ['C'] }}>
                                        <li className='lease-mobile-button'>
                                            <Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' size="small" variant="contained" color="primary" onClick={() => { setAddEditAdditionalTax({ modal: true, data: null, mode: 'add', }); handleItemClicked('Add Item Button'); }}> Add Tax Configuration </Button>
                                        </li>
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: taxList?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                        <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                            {skeletonLoader ? <STableLoader count={6} rowCount={11} /> : (
                                <Table className="mui-table-format" stickyHeader>
                                    <TaxHd
                                        sortInfo={sortInfo}
                                        createSortHandler={createSortHandler}
                                        toggleBulkOps={toggleBulkOps}
                                        item={taxList?.list}
                                        bulk={bulk}
                                    />
                                    <TableBody>
                                    {taxList?.list?.map(item => (
                                        <TaxList
                                            modeType={addEditAdditionalTax?.mode}
                                            onEdit={() => setAddEditAdditionalTax({ modal: true, data: item, mode: 'edit' })}
                                            item={item}
                                            onDelete={() => {
                                                setBulk({ modal: false, ids: [item], title: '', type: '' });
                                                setDeleteTax({ modal: true, data: item });
                                            }}
                                            onView={() => setAddEditAdditionalTax({ modal: true, data: item, mode: 'view' })}
                                            onInvStatus={onInvStatus}
                                            viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                            toggleBulkOps={toggleBulkOps}
                                            bulk={bulk}
                                        />))}
                                        </TableBody>
                                </Table>
                            )}
                            {!skeletonLoader && !taxList?.list?.length && <NoRecordFound />}
                        </div>
                        <Paper square>
                            <Pagination pagination={taxList?.pagination} onPageChange={(event, newPage) => { const pageNum = newPage + 1; setQueryConfig({ page: pageNum, per_page: taxList?.pagination?.per_page }); getTaxList({ ...filter, ...sortInfo, page: pageNum, per_page: taxList?.pagination?.per_page }); }} onRowsPerPageChange={(e) => { const perPage = Number(e.target.value); setQueryConfig({ page: 1, per_page: perPage }); getTaxList({ ...filter, ...sortInfo, page: 1, per_page: perPage }); }} />
                        </Paper>
                    </Paper>
                </div>
            </Paper>
            {isLoading ? <PageLoader /> : null}
            {/* {leaseBasicDetails?.status === "Draft" ? (<ModuleNotExcessModal moduleName="Additional Taxes" />) : leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />):<> </> } */}
            {deleteTax?.modal || bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal : deleteTax.modal}
                    title={bulk.modal ? (bulk?.ids?.length > 0 && bulk?.ids?.length === (taxList?.list?.length || 0) ? 'Delete All Tax Configuration' : 'Delete Selected Tax Configuration') : 'Delete Tax Configuration'}
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids?.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => {
                        if (bulk.modal) {
                            setBulk({ modal: false, ids: [] });
                        } else {
                            setDeleteTax({ modal: false, data: null });
                            setBulk({ modal: false, ids: [], title: '', type: '' });
                        }
                    }}
                    onDeleteRecords={() => onDeleteTax()} /> : null
            }
            {addEditAdditionalTax?.modal ?
                <AddEditAdditionalTax
                    params={params}
                    modeType={addEditAdditionalTax?.mode}
                    onToggleModal={() => setAddEditAdditionalTax({})}
                    addEditAdditionalTax={addEditAdditionalTax}
                    getResponseBack={()=> {getTaxList({...sortInfo, ...filter, page:1, per_page:50}); setBulk({modal: false, ids: [], type: '', title: ''})}}
                    usedTaxNames={(taxList?.list || [])
                        .map(item => item?.name)
                        .filter(Boolean)
                    }
                /> : null
            }
            {
                revisionHistory.modal &&
                <RevisionHistory
                    moduleName={"additional_tax"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }
        </>)

}
export default RoleBaseAccess(AdditionalTaxes, { application: 'lease_revamp', feature: 'additional_tax', operationType: ['R'], leaseNav: true });
